<template>
  <div class="space-y-8">
    <ProjectManager @view-project="setProject" @clear-project="setProject(null)" />
    <div v-if="projectId" class="space-y-8">
      <div class="flex items-center space-x-2">
        <span>Show:</span>
        <div class="inline-flex">
          <label
            class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium rounded-l"
            :class="[resources === 'both' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900']"
          >
            <input type="radio" value="both" v-model="resources" class="appearance-none" />
            both
          </label>

          <label
            class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium"
            :class="[
              resources === 'assets' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900',
            ]"
          >
            <input type="radio" value="assets" v-model="resources" class="appearance-none" />
            assets
          </label>

          <label
            class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium rounded-r"
            :class="[
              resources === 'pages' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900',
            ]"
          >
            <input type="radio" value="pages" v-model="resources" class="appearance-none" />
            pages
          </label>
        </div>
      </div>
      <ProjectAssetManager
        v-show="showAssets"
        :project-id="projectId"
        :order-item-id="orderItemId"
      />
      <ProjectPageManager v-show="showPages" :project-id="projectId" :order-item-id="orderItemId" />
    </div>
  </div>
</template>

<script>
import ProjectManager from './examplesManager/ProjectManager.vue';
import ProjectAssetManager from './examplesManager/ProjectAssetManager.vue';
import ProjectPageManager from './examplesManager/ProjectPageManager.vue';

export default {
  components: {
    ProjectManager,
    ProjectAssetManager,
    ProjectPageManager,
  },
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projectId: null,
      resources: 'both',
    };
  },
  computed: {
    showAssets() {
      return this.resources === 'both' || this.resources === 'assets';
    },
    showPages() {
      return this.resources === 'both' || this.resources === 'pages';
    },
  },
  methods: {
    setProject(project) {
      this.projectId = project?.uuid || null;
    },
  },
};
</script>
